var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("templates-loader")
    : _c(
        "div",
        { staticClass: "form-page client" },
        [
          _c(
            "div",
            { staticClass: "container-fluid" },
            [
              _c(
                "b-row",
                { staticClass: "justify-content-center" },
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "form-page px-md-5 vertical-flex-container",
                    },
                    [
                      _c("templates-header", {
                        attrs: {
                          title: _vm.getTitle,
                          subtitle: _vm.getSubtitle,
                          "back-path": _vm.backPath,
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("b-col", [
                            _c("div", { staticClass: "right-inner-addon" }, [
                              _c("i", {
                                staticClass: "fa fa-search",
                                attrs: { "aria-hidden": "true" },
                              }),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.search,
                                    expression: "search",
                                  },
                                ],
                                staticClass: "form-control search-templates",
                                attrs: {
                                  id: "search-templates",
                                  type: "search",
                                  placeholder: _vm.$t(
                                    "templates.actions.searchFor"
                                  ),
                                },
                                domProps: { value: _vm.search },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.search = $event.target.value
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  attrs: {
                                    for: "search-templates",
                                    hidden: "",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("templates.actions.searchFor")
                                    )
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.loading
                        ? _c(
                            "div",
                            {
                              staticClass: "card mortgage mt-4",
                              attrs: { id: "marketing-templates-container" },
                            },
                            [
                              _c("navbar", {
                                attrs: {
                                  "current-tab": _vm.currentTab,
                                  tabs: _vm.categories,
                                  "scroll-class": "px-4",
                                },
                                on: { "tab-change": _vm.handleTabChange },
                              }),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                {
                                  staticClass:
                                    "justify-content-end align-items-center mt-2 pb-2 pr-4",
                                  attrs: { "no-gutters": "" },
                                },
                                [
                                  _c("icon", {
                                    staticClass: "text-primary clickable mr-2",
                                    class: { disabled: _vm.refreshing },
                                    attrs: {
                                      spin: _vm.refreshing,
                                      name: "refresh",
                                    },
                                    on: { click: _vm.refreshTemplates },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "bold text-regular-gray text-right red-text",
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.$t(
                                              "templates.messages.refreshWarning"
                                            )
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                {
                                  staticClass: "pt-2 pb-4 px-4",
                                  attrs: { id: "mortgage-container" },
                                },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-2 pb-3 add-template-col",
                                      attrs: {
                                        xl: "2",
                                        lg: "4",
                                        sm: "6",
                                        cols: "12",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "add-template card mb-0",
                                          on: {
                                            click: _vm.handleTemplateCreateNew,
                                          },
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "clickable text-center",
                                              attrs: { id: "new-template" },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-plus",
                                                attrs: {
                                                  "aria-hidden": "true",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "p",
                                                {
                                                  staticClass: "add-text mb-0",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "templates.actions.createNew"
                                                        )
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.allTemplates,
                                    function (template, index) {
                                      return _c(
                                        "b-col",
                                        {
                                          key:
                                            template.templateId + "-" + index,
                                          staticClass:
                                            "mb-2 pb-3 add-template-col",
                                          attrs: {
                                            xl: "2",
                                            lg: "4",
                                            sm: "6",
                                            cols: "12",
                                          },
                                        },
                                        [
                                          _c("template-card", {
                                            attrs: {
                                              "template-name": template.name,
                                              "template-id":
                                                template.templateId,
                                              thumbnail: template.thumbnail,
                                              category: template.category,
                                              "delete-template":
                                                _vm.isUserCreated(
                                                  template.templateId
                                                ) && !_vm.isSelectPage,
                                              actions: true,
                                              "select-page": _vm.isSelectPage,
                                              "edit-template":
                                                !_vm.isSelectPage,
                                            },
                                            on: {
                                              edit: function ($event) {
                                                return _vm.handleTemplateEdit(
                                                  template.templateId
                                                )
                                              },
                                              preview: function ($event) {
                                                return _vm.handleTemplatePreview(
                                                  template.templateId
                                                )
                                              },
                                              delete: function ($event) {
                                                return _vm.handleTemplateDelete(
                                                  template.templateId
                                                )
                                              },
                                              duplicate: function ($event) {
                                                return _vm.handleTemplateDuplicate(
                                                  template.templateId
                                                )
                                              },
                                              select: function ($event) {
                                                return _vm.handleSelect(
                                                  template.templateId
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("create-email-template-modal", {
            ref: "createModal",
            attrs: {
              loading: _vm.creating,
              "create-succeeded": _vm.createSucceeded,
            },
            on: { create: _vm.createTemplate },
          }),
          _vm._v(" "),
          _c("html-template-editor", {
            ref: "templateEditorContainer",
            attrs: {
              "template-id": _vm.selectedTemplateData.templateId,
              "template-name": _vm.selectedTemplateData.name,
              "template-source-url": _vm.selectedTemplateData.url,
              "template-source-json": _vm.selectedTemplateData.json,
              "preview-template": _vm.previewTemplate,
            },
            on: {
              save: _vm.handleEditorSave,
              "create-as": _vm.handleEditorSaveAs,
              hidden: _vm.handleEditorHidden,
            },
          }),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }